<template>
  <div class="content">
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <md-button
        class="md-raised md-primary"
        to="node/new"
      >
        New Node
      </md-button>
      <md-card class="md-card-plain">
        <md-card-header data-background-color="green">
          <h4 class="title">
            Nodes
          </h4>
          <p class="category">
            List of all nodes
          </p>
        </md-card-header>
        <md-card-content>
          <nodes-table :key="componentKey" />
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
    import {NodesTable} from "@/components";

    export default {
        name: "NodesPage",
        components: {
            NodesTable,
        },
        data() {
            return {
                componentKey: 0,
                node: {
                    protocol: "",
                    ip: "",
                    serverAddress: "",
                    port: 0,
                    secret: "",
                    settings: "",
                    os: "",
                    location: {
                        longitude: "",
                        latitude: "",
                        countryCode: ""
                    },
                    capacity: 0,
                    //TODO:
                    tags: []
                },
            };
        },
        methods: {
            rerenderTable() {
                this.componentKey += 1;
            },
        }
    };
</script>

<style lang="scss">
    .new-node-dialog {
        padding: 50px 100px;
    }

    .md-dialog-container {
        width: 1200px;
    }

    .shake-on-error .md-duplicated {
        animation-name: shake;
        animation-duration: 0.5s;
    }

    @keyframes shake {
        0% {
            transform: translate(15px);
        }
        20% {
            transform: translate(-15px);
        }
        40% {
            transform: translate(7px);
        }
        60% {
            transform: translate(-7px);
        }
        80% {
            transform: translate(3px);
        }
        100% {
            transform: translate(0px);
        }
    }
</style>

<style lang="css">
    .pulse-on-error >>> .md-duplicated {
        animation-name: pulse;
        animation-duration: 0.5s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        animation-timing-function: ease-in-out
    }

    @keyframes pulse {
        0% {
            transform: scale(1.1, 1.1);
        }
        100% {
            transform: scale(0.9, 0.9);
        }
    }

    .md-menu-content {
        z-index: 110 !important;
    }
</style>
